import { useState ,useEffect} from 'react';
import './Navbar.css';

export default function Navbar({scrollToContactSection, scrollToOfferSection}) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10); // אם גוללים יותר מ־10 פיקסלים, מפעיל גבול
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="logo"> 
        <img src="/for-all-app/kerk_logo.svg" alt="Kerk Logo"  className='hero-logo-nav'  />
      </div>

      <div className={`menu-toggle ${isOpen ? 'open' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

 <ul className={`nav-links ${isOpen ? 'show' : ''}`}>
  <li onClick={() => setIsOpen(false)}>
          <button><h4>בית</h4></button>

  </li>
  {/* <li onClick={() => { scrollToOfferSection(); setIsOpen(false); }}>
    <a href="#"><h4>דילים</h4></a>
  </li> */}
  <li onClick={() => { scrollToContactSection(); setIsOpen(false); }}>
      <button><h4>צור קשר</h4></button>
  </li>
</ul>
    </nav>
  );
}
